import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sd-success-msg',
  templateUrl: './success-msg.component.html',
  styleUrls: ['./form-state-messages.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessMsgComponent {}
